import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Button } from '@pocketlaw/tetris';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
export function WorkflowCheckError() {
    const { error, rerunCheck } = useWorkflowCheck();
    const handleClick = () => {
        rerunCheck();
    };
    if (!error) {
        return null;
    }
    const messages = {
        credits: t({
            comment: 'Document workflow check - The company has no more assistant credits',
            message: 'You have insufficient credits on your account to do this action',
        }),
        setup: t({
            comment: 'Document workflow check - There was an error setting up the rules check',
            message: 'Something went wrong when setting up the rules check',
        }),
        streaming: t({
            comment: 'Document workflow check - error when there was an error streaming the response',
            message: 'Something went wrong when running the rules check',
        }),
    };
    return (<Alert appearance="danger" title={t({ comment: 'Document workflow check - Running rules error title', message: 'Error' })} message={messages[error]}>
      <Button size="xs" appearance="secondary" onClick={handleClick}>
        <Trans comment="Workflow error - Rerun button label">Rerun rules</Trans>
      </Button>
    </Alert>);
}
